import {
  GET_SALESCHANNEL,
  GET_SALESCHANNEL_SUCCESS,
  GET_SALESCHANNEL_FAIL,
  DELETE_SALESCHANNEL,
  DELETE_SALESCHANNEL_SUCCESS,
  DELETE_SALESCHANNEL_FAIL,
  UPDATE_SALESCHANNEL,
  UPDATE_SALESCHANNEL_SUCCESS,
  UPDATE_SALESCHANNEL_FAIL,
  ADD_NEW_SALESCHANNEL,
  ADD_SALESCHANNEL_SUCCESS,
  ADD_SALESCHANNEL_FAIL,
  SALESCHANNEL_LOADING,
  SALESCHANNEL_RESET,
} from "./actionType";

export const resetSalesChannelState = (actionType) => ({
  type: SALESCHANNEL_RESET,
  payload: { actionType },
});

export const getSalesChannelSuccess = (actionType, data) => ({
  type: GET_SALESCHANNEL_SUCCESS,
  payload: { actionType, data },
});

export const getSalesChannelFail = (actionType, error) => ({
  type: GET_SALESCHANNEL_FAIL,
  payload: { actionType, error },
});

export const getSalesChannel = data => ({
  type: GET_SALESCHANNEL,
  payload: data,
});

export const getSalesChannelLoading = () => ({
  type: SALESCHANNEL_LOADING
});

export const deleteSalesChannel = data => ({
  type: DELETE_SALESCHANNEL,
  payload: data,
});

export const deleteSalesChannelSuccess = data => ({
  type: DELETE_SALESCHANNEL_SUCCESS,
  payload: data,
});

export const deleteSalesChannelFail = error => ({
  type: DELETE_SALESCHANNEL_FAIL,
  payload: error,
});

export const updateSalesChannel = data => ({
  type: UPDATE_SALESCHANNEL,
  payload: data,
});

export const updateSalesChannelFail = error => ({
  type: UPDATE_SALESCHANNEL_FAIL,
  payload: error,
});

export const updateSalesChannelSuccess = data => ({
  type: UPDATE_SALESCHANNEL_SUCCESS,
  payload: data,
});

export const addNewSalesChannel = data => ({
  type: ADD_NEW_SALESCHANNEL,
  payload: data,
});

export const addSalesChannelSuccess = data => ({
  type: ADD_SALESCHANNEL_SUCCESS,
  payload: data,
});

export const addSalesChannelFail = error => ({
  type: ADD_SALESCHANNEL_FAIL,
  payload: error,
});